import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=5296fa1e&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=5296fa1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5296fa1e",
  null
  
)

export default component.exports